import { useContext } from 'react';
import { AppContext } from '~/contexts/app.context';

export default function useAppContext() {
	const context = useContext(AppContext);
	if (!context) {
		throw new Error('useAppContext can only be used inside AppContextProvider');
	}
	return context;
}
